import { useWakeLockStore } from "./store";
import type { WakeLockContext } from "./types";

export function useWakeLock(): WakeLockContext {
  return useWakeLockStore();
}
